import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Field from '../../../../components/fields'

const Paragraph = styled.p`
  font-size: 14px;
  margin: 14px 0px;
`

const CustomIdInputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

const CustomIdLabel = styled.span`
  min-width: 90px;
`

const CustomIdInput = styled.div`
  flex: 1;
  max-width: 440px;
`

type CustomIdProps = {
  homeSettings: Record<string, any>
  formId: string
}

export const CustomId = ({ homeSettings, formId }: CustomIdProps) => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  return (
    <>
      <Paragraph>{t(generalConstants.CUSTOM_ID_DESC)}</Paragraph>
      <CustomIdInputRow>
        <CustomIdLabel>{t(generalConstants.CUSTOM_ID)}</CustomIdLabel>
        <CustomIdInput>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="customId"
              label=""
              layout="no-label"
              formId={formId}
              type="text"
              placeholders={t(generalConstants.CUSTOM_ID_PLACEHOLDER)}
              values={homeSettings}
            />
          </Suspense>
        </CustomIdInput>
      </CustomIdInputRow>
    </>
  )
}
